import { render, staticRenderFns } from "./GameSeedPhase.vue?vue&type=template&id=e3d4c21e&scoped=true&"
import script from "./GameSeedPhase.vue?vue&type=script&lang=js&"
export * from "./GameSeedPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d4c21e",
  null
  
)

export default component.exports